/* eslint-disable no-undef */
export default {
  data() {
    return {
      placeSearchTimer: null,
      placesService: null,
    };
  },

  mounted() {
    if (!window.google) {
      // used together with AddressSearch
      // If google SDK fails to load, error message will be visible inside AddressSearch component
      return;
    }
    this.placesService = new google.maps.places.PlacesService(document.getElementById('map-container'));
  },

  methods: {
    // put on address field @input event. After user updates those fields manually,
    // they are concatenated into an address string which is used to retrieve the postal code of that address.
    // This was put here to prevent users from entering incorrect postal codes manually
    setPostalCode(address) {
      clearTimeout(this.placeSearchTimer);
      this.placeSearchTimer = setTimeout(() => {
        const request = {
          query: address,
          fields: ['formatted_address'],
        };
        this.placesService.findPlaceFromQuery(request, (res) => {
          if (!res || !res.length) {
            return;
          }
          const parts = res[0].formatted_address.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '').split(' ');
          let postalCode = '';
          parts.forEach((p) => {
            if (p.length === 5 && !Number.isNaN(p)) {
              postalCode = p;
            }
          });
          if (postalCode) {
            postalCode = `LT-${postalCode}`;
          }
          this.$set(this.client, 'address_post_code', postalCode);
        });
      }, 500);
    },
  },
};
